import { ReactElement, ReactNode } from 'react'
import { Result } from 'antd'

import questionMark from '../../assets/img/question-mark.png'

/**
 * Shown when a participation link can't be resolved (e.g. a rotated/replaced
 * link). Uses the "question mark" illustration; callers supply the sub-title
 * since the guidance differs slightly between the authed and ad-hoc flows.
 */
export function ParticipationInvalidResult({ subTitle }: { subTitle: ReactNode }): ReactElement {
  return (
    <Result
      icon={<img src={questionMark} alt="" style={{ width: 240, maxWidth: '100%', height: 'auto' }} />}
      title="Not Found"
      subTitle={
        <span style={{ fontSize: 16, color: 'rgba(0, 0, 0, 0.65)' }}>
          This participation link is no longer valid. {subTitle}
        </span>
      }
    />
  )
}
